"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/History/Mobile/ParticipantDetails.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);








const ParticipantDetails = ({
  participantName,
  startedAt,
  duration,
  rating,
}) => (
  _react2.default.createElement('div', { className: "meeting-room--mobile-history--details-session", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
    , _react2.default.createElement('div', { className: "meeting-room--mobile-history--session-main-col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
      , _react2.default.createElement('div', { className: "meeting-room--mobile-history--session-participant-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
        , _react2.default.createElement('span', { className: "meeting-room--mobile-history--session-participant-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
          ,  participantName || 'Unknown' 
        )
        , _react2.default.createElement('span', { className: "meeting-room--mobile-history--session-time", __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
          ,  startedAt 
        )
      )
    )
    , _react2.default.createElement('div', { className: "meeting-room--mobile-history--session-sub-col", __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
      , _react2.default.createElement('span', { className: "meeting-room--mobile-history--session-duration", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}},  duration )
      , _react2.default.createElement('div', { className: "meeting-room--mobile-history--session-feedback", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
        , 
          Array(5).fill(0).map((_, i) => (
            _react2.default.createElement('div', {
              key: i,
              className: _classBuilder2.default.call(void 0, 
                "meeting-room--mobile-history--session-feedback--point",
                // A missing rating compares like 0 in JS: no point is active.
                { active: i + 1 <= (_nullishCoalesce(rating, () => ( 0))) },
              ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
            )
          ))
        
      )
    )
  )
)

exports. default = ParticipantDetails
